import client from "./client";

/** 노출중인 공지사항 목록 (최근순, 상단고정 우선) */
export async function getNotices(limit = 10) {
  const res = await client.get("/notice", { params: { limit } });
  return res.data;
}
